import {
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";

import { useAuthStore } from "../stores/authStore";

export function ProtectedRoute() {
  const location = useLocation();

  const user = useAuthStore(
    (state) => state.user,
  );

  const token = useAuthStore(
    (state) => state.token,
  );

  const isAuthenticated = Boolean(
    user && token,
  );

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location,
        }}
      />
    );
  }

  return <Outlet />;
}

export function PublicOnlyRoute() {
  const user = useAuthStore(
    (state) => state.user,
  );

  const token = useAuthStore(
    (state) => state.token,
  );

  const isAuthenticated = Boolean(
    user && token,
  );

  if (isAuthenticated) {
    return (
      <Navigate
        to="/"
        replace
      />
    );
  }

  return <Outlet />;
}